module.exports = __webpack_public_path__ + "static/Default-fade17280461d799ff2bd49945795dd3.jpg";